import ContentActionViewLikes from '../content-actions/content-action-view-likes';

interface MobileReactionsFooterProps {
  contentId: number;
}

export const MobileReactionsFooter = ({
  contentId,
}: MobileReactionsFooterProps) => {
  return (
    <div className="mobile-reactions-footer">
      <div className="mobile-reactions-bar">
        <ContentActionViewLikes contentId={contentId} />
      </div>
    </div>
  );
};
